import { render } from "./virtual-delivery.vue?vue&type=template&id=536ed1f9"
import script from "./virtual-delivery.vue?vue&type=script&lang=js"
export * from "./virtual-delivery.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__